/**
 * Hide element if it has no permission
 */
import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnDestroy,
  EmbeddedViewRef,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { PermissionsService } from '../permissions.service';
import { Subscription } from 'rxjs';

/*
 * @example:
 *   <input type="text" placeholder="please no"
 *      *xviIfHasPermissions="['VenuesInventory.Transfer.Add']">
 *
 *      <input type="text" placeholder="please no"
 *      *xviIfHasPermissions="['VenuesInventory.Transfer.Add'] appCode 'xvi'">
 */
@Directive({
  selector: '[xviIfHasPermissions]',
})
export class IfHasPermissionDirective implements OnInit, OnDestroy {
  /* eslint-disable @angular-eslint/no-input-rename */
  @Input('xviIfHasPermissions') public permissions: string[];
  @Input('xviIfHasPermissionsAppCode') public appCode: string;
  /* eslint-enable @angular-eslint/no-input-rename */
  private context: IfHasPermissionsContext = new IfHasPermissionsContext();
  private viewRef: EmbeddedViewRef<IfHasPermissionsContext> | null = null;

  public constructor(
    private changeDetector: ChangeDetectorRef,
    private templateRef: TemplateRef<IfHasPermissionsContext>,
    private viewContainer: ViewContainerRef,
    private permissionsService: PermissionsService,
  ) {}

  public ngOnInit(): void {
    this.context.requiredPermissions = this.permissions;

    if (this.context.hasPermissionSubscription) {
      this.context.hasPermissionSubscription.unsubscribe();
    }

    this.context.hasPermissionSubscription = this.permissionsService
      .trackPermissionsChange(this.permissions || [], this.appCode)
      .subscribe((hasPermission) => {
        this.updateView(hasPermission);
      });
  }

  public ngOnDestroy(): void {
    if (this.context.hasPermissionSubscription) {
      this.context.hasPermissionSubscription.unsubscribe();
    }
  }

  private updateView(hasPermission: boolean): void {
    if (hasPermission) {
      if (!this.viewRef) {
        this.viewContainer.clear();
        if (this.templateRef) {
          this.viewRef = this.viewContainer.createEmbeddedView(
            this.templateRef,
            this.context,
          );
        }
      }
    } else {
      this.viewContainer.clear();
      this.viewRef = null;
    }
    this.changeDetector.markForCheck();
  }
}

/**
 * @stable
 */
export class IfHasPermissionsContext {
  public hasPermissionSubscription: Subscription | null = null;
  public requiredPermissions: string[] = [];
}
